import { Link } from "wouter";
import { useTranslation } from "react-i18next";
import { useSiteSettings } from "@/lib/cms";

export function Footer() {
  const { t } = useTranslation();
  const { brand } = useSiteSettings();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-brand-100 py-8 bg-white">
      <div className="container flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-brand-500">
        <div className="font-heading uppercase tracking-widish text-brand-700 text-sm">
          {brand.name}
        </div>
        <nav className="flex gap-6">
          <Link
            href="/o/adatvedelem"
            className="text-brand-500 hover:text-accent uppercase tracking-widish"
          >
            {t("footer.privacy")}
          </Link>
          <Link
            href="/o/impresszum"
            className="text-brand-500 hover:text-accent uppercase tracking-widish"
          >
            {t("footer.imprint")}
          </Link>
          <Link
            href="/admin"
            className="text-brand-300 hover:text-accent uppercase tracking-widish text-[10px]"
          >
            Admin
          </Link>
        </nav>
        <div>
          © {brand.name} {year}. {t("footer.rights")}.
        </div>
      </div>
    </footer>
  );
}
